// Função para gerar laudo textual baseado nos dados do eco
// Pode ser usado para gravar no campo OBSERVACOES (tipo TEXT)

function mapListSectionText(title, array, keyField = 'DESCRICAO') {
  if (!array || array.length === 0) return '';
  let text = `\n${title}:\n`;
  array.forEach(item => {
    text += `  - ${item[keyField]}\n`;
  });
  return text;
}

function mapSingleFieldText(label, value, unit = '', precision = 2) {
  if (value == null || value === '') return '';
  let fieldValue;
  if (isNaN(value)) {
    fieldValue = value;
  } else {
    fieldValue = Number(value).toFixed(precision);
  }
  return `  - ${label}: ${fieldValue} ${unit}`.trim() + '\n';
}

function mapMixedSectionText(
  title,
  numbers = [],
  list = [],
  keyField = 'DESCRICAO'
) {
  let text = '';
  if ((numbers && numbers.length > 0) || (list && list.length > 0)) {
    text += `\n${title}:\n`;
    numbers.forEach(n => {
      if (n && n.value != null && n.value !== '') {
        text += `  - ${n.label}: ${n.value} ${n.unit || ''}\n`;
      }
    });
    list.forEach(item => {
      text += `  - ${item[keyField]}\n`;
    });
  }
  return text;
}

function generateDopplerTextReport(eco) {
  let text = '';
  text += 'ECOCARDIOGRAMA DOPPLER\n';
  text += mapSingleFieldText(
    'Nome do Paciente',
    `${eco.CODPAC} - ${eco.NOMEPAC}`
  );
  if (eco.CPFPAC) text += mapSingleFieldText('CPF', eco.CPFPAC);
  text += mapSingleFieldText('Data de Nasc', eco.dataNascFmt, '', 0);
  text += mapSingleFieldText('Sexo', eco.SEXOPAC);
  text += mapSingleFieldText('Idade', eco.idadePAC, 'anos', 0);
  text += mapSingleFieldText('Convênio', eco.SIGLACONV);
  text += mapSingleFieldText('Cod Laudo', eco.CODECO);
  text += mapSingleFieldText('Data do Exame', eco.dataEcoFmt);
 /*  text += mapSingleFieldText(
    'Médico que Realizou',
    `${eco.prefixoRealizou || ''} ${eco.Realizou}`
  ); */
  text += mapSingleFieldText(
    'Médico que Solicitou',
    `${eco.prefixoSolicitou || ''} ${eco.Solicitou}`
  );

  if (eco.obs) {
    text += '\nObservações:\n';
    eco.obs.forEach(o => {
      text += `  - ${o.DESCRICAO || 'Descrição não encontrada'}\n`;
    });
  }

  text += '\nDiâmetros e Função Sistólica do Ventrículo Esquerdo:\n';
  text += mapSingleFieldText('Septo', eco.SEPTO, 'cm');
  text += mapSingleFieldText('PPVE', eco.PPVE, 'cm');
  text += mapSingleFieldText('Diâmetro Diastólico', eco.DD, 'cm');
  text += mapSingleFieldText('Diâmetro Sistólico', eco.DS, 'cm');
  text += mapSingleFieldText(
    'Fração de Ejeção (Monoplanar)',
    eco.fracaoEjecaoMono,
    '%'
  );
  text += mapSingleFieldText(
    'Fração de Ejeção (Simpson)',
    eco.FRAEJECBIPLA,
    '%'
  );
  text += mapSingleFieldText('Fração de Ejeção (3D)', eco.FRAEJE3D, '%');
  text += mapSingleFieldText('Massa do VE', eco.massaVE, 'g/m2');
  text += mapSingleFieldText('Relação Espessura/Volume', eco.avaliaVSVE);

  text += mapListSectionText('Achados Descritivos do VE', eco.achados);
  text += mapListSectionText('Contração Segmentar', eco.contraRegiao);
  text += mapSingleFieldText('Índice de Performance', eco.indicePM);
  text += mapSingleFieldText(
    'Estimativa do Débito Cardíaco',
    eco.estimativaDC,
    'l/min/m2'
  );
  text += mapListSectionText('Avaliação Diastólica', eco.avDiast);
  text += mapListSectionText('Ventrículo Direito', eco.ventriDir);
  text += mapSingleFieldText('Diâmetro do Átrio Esquerdo', eco.DAE, 'cm');
  text += mapSingleFieldText('Volume do AE', eco.VOL_AE, 'cc/m2');
  text += mapListSectionText('Átrio Esquerdo', eco.atrioEsq);
  text += mapListSectionText('Átrio Direito', eco.atrioDir);
  text += mapListSectionText('Valva Mitral', eco.valvaMitral);
  text += mapMixedSectionText(
    'Doppler Mitral',
    [
      { label: 'Área Valva Mitral', value: eco.AVM },
      { label: 'Orifício Regurgitação Mitral (PISA)', value: eco.ORIFICIO_VM },
      { label: 'Gradiente Médio', value: eco.GMVM },
      { label: 'Volume Regurgitação Mitral', value: eco.VOLUME_VM },
    ],
    eco.refVM
  );
  text += mapMixedSectionText(
    'Prótese Mitral',
    [{ label: 'Gradiente Médio da Prótese Mitral', value: eco.GMPM }],
    eco.refluxoPM
  );
  text += mapListSectionText('Valva Aórtica', eco.valvaAO);
  text += mapMixedSectionText(
    'Doppler Aórtico',
    [
      { label: 'Área Valva Aórtica', value: eco.AREA_AO },
      { label: 'Gradiente Médio Valva Aórtica', value: eco.GMVAO },
      { label: 'Gradiente Médio Via de Saída VE', value: eco.GMVSVE },
    ],
    eco.refVAO
  );
  text += mapMixedSectionText(
    'Prótese Aórtica',
    [{ label: 'Gradiente Médio da Prótese Aórtica', value: eco.GMPAO }],
    eco.refluxoPAO
  );
  text += mapListSectionText('Valva Tricúspide', eco.valvaTricu);
  text += mapMixedSectionText(
    'Doppler Tricúspide',
    [
      { label: 'Gradiente Médio da Valva Tricúspide', value: eco.GMVT },
      { label: 'Estimativa Pressão Sistólica AP', value: eco.estimativaPSVD },
    ],
    eco.refVT
  );
  text += mapMixedSectionText(
    'Prótese Tricúspide',
    [{ label: 'Gradiente Médio da Prótese Tricúspide', value: eco.GMPT }],
    eco.refluxoPT
  );
  text += mapListSectionText('Valva Pulmonar', eco.valvaPulmo);
  text += mapMixedSectionText(
    'Doppler Pulmonar',
    [{ label: 'Gradiente Médio da Valva Pulmonar', value: eco.GMVP }],
    eco.refVP
  );
  text += mapMixedSectionText(
    'Prótese Pulmonar',
    [{ label: 'Gradiente Médio da Prótese Pulmonar', value: eco.GMPP }],
    eco.refluxoPP
  );
  text += mapListSectionText('Pericárdio', eco.pericardio);
  text += mapListSectionText('Veia Cava Inferior', eco.veiaCavaInf);
  text += mapListSectionText('Aorta', eco.aorta);

  if (eco.OBSERVACOES?.trim()) {
    text += `\nObservações:\n  - ${eco.OBSERVACOES.trim()}\n`;
  }

  text += mapListSectionText('Conclusões', [
    ...(eco.valvulopatia || []).map(v => ({ DESCRICAO: v.valvulopatia })),
    ...(eco.protese || []).map(p => ({ DESCRICAO: p.protese })),
    ...(eco.contraSeg || []).map(c => ({ DESCRICAO: c.contraSeg })),
    ...(eco.conclusoes || []).map(c => ({ DESCRICAO: c.conclusoes })),
  ]);

  text += `\nConferido e assinado eletronicamente por: ${eco.Realizou}\n`;
  // Não inclui assinatura digital (md5) no texto simples

  return text;
}

export default generateDopplerTextReport;
